/**
 * Normalizes a string for alphabetical sorting by lowercasing and
 * mapping German umlauts / ß to their base-letter equivalents.
 */
export const normalizeForSort = value => String(value !== null && value !== void 0 ? value : '').toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss');